module.exports = __webpack_public_path__ + "static/media/kudo_c.98949268.svg";